// extracted by mini-css-extract-plugin
module.exports = {"loader":"spinner_loader___f4c8","l7":"spinner_l7__gDHYe"};